import React from "react";
import ContentDetail from "../components/Feed/ContentDetail";
import Sidebar from "../components/Layouts/Sidebar";
import Bottom from "../components/Layouts/Bottom";

const FeedDetail = () => {
  const goBack = () => {
    window.history.back();
  };
  return (
    <>
      <div className="full-sec">
        <div className="left-sec col-md-3">
          <Sidebar />
        </div>
        <div className="right-sec col-md-9 profile-content-list feed-detail-section">
          <div className="back-btn">
            <a href="javascript:void(0)" className="back-btn-a" onClick={goBack}>
              <img src="/quickplay/images/arrow-small-right.svg" />
              <span>Back</span></a>
          </div>
          <ContentDetail />
        </div>
      </div>
      <Bottom />
    </>
  );
};

export default FeedDetail;
